import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';


import { UserInfo } from '@/shared/models/UserInfo.model';
import { RootState } from '../RootState';
import { Role } from '@/shared/enums/Role.enum';


/**
 * Constantes pour les méthodes du store.
 */
export enum SecurityStoreMethods {
    GET_USERINFO = 'GET_USERINFO',
    GET_USERSHOULDSIGNCGU = 'GET_USERSHOULDSIGNCGU',
    GET_USER_SHOULD_SIGN_TEMPLATE_POS = 'GET_USER_SHOULD_SIGN_TEMPLATE_POS',
    GET_DATE_NOTIFICATION_POS = 'GET_DATE_NOTIFICATION_POS',
    GET_IS_USER_ADMIN = 'GET_IS_USER_ADMIN',
    GET_CONNEXION_EN_COURS = 'GET_CONNEXION_EN_COURS',
    GET_CONNEXION_SUCCESS = 'GET_CONNEXION_SUCCESS',
    SET_USERINFO = 'SET_USERINFO',
    SET_USER_HAS_SIGNED_CGU = 'SET_USER_HAS_SIGNED_CGU',
    SET_USER_HAS_SIGNED_TEMPLATE_POS = 'SET_USER_HAS_SIGNED_TEMPLATE_POS',
    SET_CONNEXION_EN_COURS = 'SET_CONNEXION_EN_COURS',
    SET_CONNEXION_SUCCESS = 'SET_CONNEXION_SUCCESS'
}

/**
 * Modèle du store de Sécurité.
 */
export class SecurityState {
    /**
     * L'utilisateur courant.
     */
    public userInfo: UserInfo | undefined = undefined;

    public connexionSuccess = false;

    public connexionEnCours = false;
}

/**
 * Getters du store.
 */
const getters: GetterTree<SecurityState, RootState> = {
    [SecurityStoreMethods.GET_USERINFO]: (security) => security.userInfo,
    [SecurityStoreMethods.GET_IS_USER_ADMIN]: (security) => security.userInfo && security.userInfo.roleId === Role.Administrateur,
    [SecurityStoreMethods.GET_USERSHOULDSIGNCGU]: (security) => security.userInfo ? security.userInfo.shouldSignCgu : undefined,
    [SecurityStoreMethods.GET_USER_SHOULD_SIGN_TEMPLATE_POS]: (security) => security.userInfo ? security.userInfo.shouldSignTemplatePos : undefined,
    [SecurityStoreMethods.GET_DATE_NOTIFICATION_POS]: (security) => security.userInfo ? security.userInfo.dateNotificationPos : undefined,
    [SecurityStoreMethods.GET_CONNEXION_EN_COURS]: (security) => security.connexionEnCours,
    [SecurityStoreMethods.GET_CONNEXION_SUCCESS]: (security) => security.connexionSuccess,

};

/**
 * Mutateurs du store.
 */
const mutations: MutationTree<SecurityState> = {
    [SecurityStoreMethods.SET_USERINFO]: (state: SecurityState, userInfo: UserInfo | undefined) => state.userInfo = userInfo,
    [SecurityStoreMethods.SET_USER_HAS_SIGNED_CGU]: (state: SecurityState) => {
        if (state.userInfo) {
            state.userInfo.shouldSignCgu = false;
            state.userInfo.dateNotificationPos = undefined;
        }
    },
    [SecurityStoreMethods.SET_USER_HAS_SIGNED_TEMPLATE_POS]: (state: SecurityState) => {
        if (state.userInfo) {
            state.userInfo.shouldSignTemplatePos = false;
        }
    },

    [SecurityStoreMethods.SET_CONNEXION_EN_COURS]: (state: SecurityState, value : boolean) => state.connexionEnCours = value,
    [SecurityStoreMethods.SET_CONNEXION_SUCCESS]: (state: SecurityState, value : boolean) => state.connexionSuccess = value,
};

/**
 * Actions du store.
 */
const actions: ActionTree<SecurityState, RootState> = {
};

/**
 * Export du module
 */
export const SecurityStore: Module<SecurityState, RootState> = {
    state: new SecurityState(),
    getters,
    mutations,
    actions,
    namespaced: false
};
